export default __webpack_public_path__ + "static/media/regulatory--no-motor-vehicles-except-motorcycles--g2.7d175930.png";